import * as React from 'react';
import { theme } from '@Guidelines/Theme/theme';

const query = `(max-width: ${theme.layout.compactBreakpoint})`;

const hasMatchMedia = (): boolean => typeof window !== 'undefined' && typeof window.matchMedia === 'function';

// Module-level so the reference is stable and React does not resubscribe on every render.
const subscribe = (onChange: () => void): (() => void) => {
	if (!hasMatchMedia()) {
		return () => undefined;
	}

	const mediaQueryList = window.matchMedia(query);
	mediaQueryList.addEventListener('change', onChange);

	return () => {
		mediaQueryList.removeEventListener('change', onChange);
	};
};

const getSnapshot = (): boolean => (hasMatchMedia() ? window.matchMedia(query).matches : false);

const getServerSnapshot = (): boolean => false;

/** True below the compact breakpoint. Falls back to `false` where `matchMedia` is unavailable. */
const useIsCompactViewport = (): boolean =>
	React.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);

export default useIsCompactViewport;
